import { createReducer, on } from '@ngrx/store';
import * as fromOptly from '@optly/store/actions/optly.action';
import { StateSlice } from '@core/helpers/state-slice';

export type OptlyState = StateSlice<string[]>;

export const initialState: OptlyState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
};

const optlyReducer = createReducer(
  initialState,
  on(fromOptly.loadExperiments, (state, { payload }) => {
    const data = [...state.data];

    payload.forEach((experiment) => {
      data.indexOf(experiment) === -1 && data.push(experiment);
    });

    return {
      ...state,
      data,
      loaded: true,
    };
  })
);

export function reducer(
  state: OptlyState | undefined,
  action: fromOptly.OptlyActions
) {
  return optlyReducer(state, action);
}
